import signedFetch from '../util/signedFetch.js';

export default ({ placementTestId }) => {
  const URL = `${__API_BASE__}/placementTest/${placementTestId}/results`;

  return signedFetch('loadPlacementTestResults', URL, 'GET');
};
